import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
var ClickOutside = /*#__PURE__*/function (_React$Component) {
  _inherits(ClickOutside, _React$Component);
  var _super = _createSuper(ClickOutside);
  function ClickOutside(props) {
    var _this;
    _classCallCheck(this, ClickOutside);
    _this = _super.call(this, props);
    _this.handleDocumentMouseDown = function () {
      if (_this.isClickedInside) {
        _this.isClickedInside = false;
        return;
      }
      _this.props.clickOutside();
    };
    _this.handleMouseDown = function (e) {
      _this.isClickedInside = true;
    };
    _this.isClickedInside = false;
    return _this;
  }
  _createClass(ClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleDocumentMouseDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleDocumentMouseDown);
    }
  }, {
    key: "render",
    value: function render() {
      return React.cloneElement(React.Children.only(this.props.children), {
        onMouseDownCapture: this.handleMouseDown
      });
    }
  }]);
  return ClickOutside;
}(React.Component);
export default ClickOutside;